export enum SidebarQueryKey {
  LessonPageId = 'lessonPageId',
  Tab = 'tab',
}

export enum CourseActions {
  AddSection = 'SECTION_ADD',
  AddLesson = 'LESSON_ADD',
  MoveLesson = 'MOVE_LESSON',
  RenameSectionOrLesson = 'RENAME_LESSON_OR_SECTION',
  SaveLessonCustomDuration = 'SAVE_LESSON_CUSTOM_DURATION',
  SetLessonCover = 'SET_LESSON_COVER',
  SetLessonQuestions = 'SET_LESSON_QUESTIONS',
  Remove = 'REMOVE_LESSON_OR_SECTION',
  Back = 'BACK',
  BackToHome = 'BACK_TO_HOME',
  BackToPath = 'BACK_TO_PATH',
  SetOptional = 'SET_OPTIONAL',
  SetLessonUpdatedAtAttr = 'SET_LESSON_UPDATED_AT_ATTR',
}

export enum CourseNavPage {
  CourseBuilder = 'CourseBuilder',
  CourseViewer = 'CourseViewer',
}

export enum CourseError {
  CourseEmpty = 'Course:CourseCannotBeEmpty',
  SectionEmpty = 'Course:Section.SectionCannotBeEmpty',
}

export enum LessonStatusTypes {
  None = 'NO_STATUS',
  ToDo = 'TO_DO',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  Done = 'DONE',
}
